module.exports = __webpack_public_path__ + "static/media/clouds.b17d71c4.svg";